var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8995 12.0001L20.4853 10.5859L19.0711 12.0001L17.6569 10.5859L16.2426 12.0001L14.8284 10.5859L13.4142 12.0001L12 10.5859L10.5858 12.0001L9.17157 10.5859L7.75736 12.0001L6.34315 10.5859L4.92893 12.0001L3.51472 10.5859L2.10051 12.0001L3.51472 13.4143L4.92893 12.0001L6.34315 13.4143L7.75736 12.0001L9.17157 13.4143L10.5858 12.0001L12 13.4143L13.4142 12.0001L14.8284 13.4143L16.2426 12.0001L17.6569 13.4143L19.0711 12.0001L20.4853 13.4143L21.8995 12.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusM);
export default __webpack_public_path__ + "static/media/minus-m.bebbb4c91fd193a99152accc7188d4c6.svg";
export { ForwardRef as ReactComponent };